import { Card, CardContent, Grid, Box } from '@mui/material';
import { ClientContactDTO } from 'wisestep-api';
import { WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import UserProfileInfoRender from '../../../recruiterProfileDetails/components/userProfile/UserProfileInfoRender';

interface UserDetailsProps {
  clientContactInfo: ClientContactDTO;
}

const ContactProfileDetails = ({ clientContactInfo }: UserDetailsProps) => {
  const contactDetails = (clientContactInfo: ClientContactDTO) => [
    { label: 'Email', value: clientContactInfo.emailAddress },
    { label: 'Entity Type', value: clientContactInfo.entityType?.[0] },
    { label: 'Phone Number', value: clientContactInfo.phoneNumber },
    { label: 'Tags', value: clientContactInfo.tags?.join(', ') },
    {
      label: 'Location',
      value: `${
        [
          clientContactInfo?.location?.city,
          clientContactInfo?.location?.state,
          clientContactInfo?.location?.country,
        ]
          .filter(Boolean)
          .join(', ') || '-'
      }`,
    },
    { label: 'Position', value: clientContactInfo.position },
    { label: 'Owner', value: clientContactInfo?.ownerId ?? '-' },
    { label: 'Supervisor', value: clientContactInfo?.supervisor?.firstName ?? '-' },
  ];

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
      <Box
        sx={{
          backgroundColor: WsColors.White,
          px: 2,
          py: 1,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }}
      >
        <WsTypography variant={WsTypoVariants.TITLE} bold>
          Client Contact Details
        </WsTypography>
      </Box>
      <CardContent>
        <Grid container spacing={3}>
          <UserProfileInfoRender fields={contactDetails(clientContactInfo)} />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ContactProfileDetails;
